import moment from 'moment';


export const last7DaysArray = () => {
  const last7Days = [];

for (let i = 6; i >= 0; i--) {
  last7Days.push(moment.utc().subtract(i, 'days').format("MMM DD"));
}
return last7Days;
}
